<template>
  <div>
    <headerSection></headerSection>
    <div id="main__content" class="">
      <div class="x-main-container">
        <div class="x-main-content">
            <div class="x-promotion-index" :style="{'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="x-page-title-component -long-support">
                                <div class="-inner-wrapper">
                                <h1 class="-title">แบร์นทั้งหมดที่ดีที่สุด รวมอยู่ในที่นี่แล้ว</h1>
                                </div>
                            </div>
                            <p class="-description">ฝาก ไม่รับโบนัส, ถอนได้ทันทีไม่มีเงื่อนไข</p>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div style=" display: flex; justify-content: space-between; margin-top: 8px;">
                        <div>
                            <a href="javascript:void(0)" @click="moveCreditToWallet()" class="text-white js-account-approve-aware btn -btn-deposit" style="height: 40px;min-width:120px;" data-toggle="modal">
                                 <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โยกเงินออกทั้งหมด</div>
                            </a>
                        </div>
                        <div class="-deposit-container d-lg-block" style="justify-content: flex-end; display: flex !important; height: 40px">
                            <a href="javascript:void(0)" @click="refreshCredit()" style="min-width:120px;" class="text-white js-account-approve-aware btn -btn-withdraw" data-toggle="modal">
                                 <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">รีเฟรสเครดิตทั้งหมด</div>
                            </a>
                        </div>
                    </div>
                    <div class="row -row-wrapper x-divine-gutter">

                        <div class="col-12 col-md-6 mt-3 -col-wrapper x-divine-gutter animated fadeInUp" style="padding-bottom: 8px;padding-top: 10px;" data-animatable="fadeInUp" data-delay="100" v-for="(item,index) in sites" :key="index">
                            <div style="box-shadow: 0 0 3px 3px red; position: absolute;right:10px;top:0px;background-color:#1A1A1A;padding:6px;z-index: 2;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">จำนวนเครดิต : {{getCredit(item.key)}}</div>
                            <template v-if="item && item.status && user && user.web && user.web[item.key] && user.web[item.key].status">
                              <a :href="'/playgame/'+item.key" target="_blank" class="x-promotion-list-item">
                                  <picture>
                                  <img class="-cover-img img-fluid" :style="getStyleStatus(item)" :alt="item.name" width="200" height="200" :src="require('../assets/images/'+item.image)">
                              </picture>
                              </a>
                            </template>
                            <template v-else>
                              <picture class="x-promotion-list-item">
                                  <img class="-cover-img img-fluid" :style="getStyleStatus(item)" :alt="item.name" width="200" height="200" :src="require('../assets/images/'+item.image)">
                              </picture>
                            </template>
                        </div>

                    </div>
                </div>

                <div class="container mt-4">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="-sub-title"><a href="https://supermax168.in">SuperMax168</a>&nbsp;คาสิโนชั้นนำ รวมแบร์นดัง มีทุกค่าย รับง่าย ถอนไว</h2>
                            <p class="-description">
                                ศูนย์รวมแบร์นที่ดีทีสุดและเกมส์คาสิโนทุกเกมส์ไว้ที่นี่ที่เดียว อาทิ UFA IMI LUNAR EDMBET และ Betflix เฉพาะครอบครัว SuperMax168 เท่านั้น
                            </p>
                        </div>
                    </div>
                </div>
            </div>

          <footerSection></footerSection>
        </div>
      </div>

      <div class="x-right-sidebar-container"></div>

    </div>
  </div>
</template>

<script>
const axios = require('axios').default
export default {
  name: 'Play',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  created () {
      	window.addEventListener('focus', this.startTimer)
    // Inactive
    // window.addEventListener('blur', this.stopTimer);
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
  	sites () {
      return this.$store.state.user.sites
    },
    sites_credit () {
      return this.$store.state.user.sites_credit
    }
  },
  mounted () {
    this.$store.dispatch('user/getSites').catch(err => { console.error(err) })
    this.$store.dispatch('user/refreshCreditAll').catch(err => { console.error(err) })
  },
  methods: {
    // stopTimer(){
    // 	console.log('UnActive')
    // },
    startTimer () {
      this.$store.dispatch('user/refreshCreditAll').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    numberWithCommas (x) {
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    moveCreditToWallet () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/moveCreditToWallet').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    refreshCredit () {
      this.$store.commit('user/SET_LOADING', true)
      this.$store.dispatch('user/refreshCreditAll').finally(res => { this.$store.commit('user/SET_LOADING', false) }).catch(err => { console.error(err) })
    },
    getStyleStatus (item) {
      if (item && item.status && this.user && this.user.web && this.user.web[item.key] && this.user.web[item.key].status) return 'border-radius:0px;'
      return 'border-radius:0px;-webkit-filter: grayscale(100%);filter: grayscale(100%);'
    },
    getCredit (key) {
      if (this.sites_credit[key] && this.sites_credit[key].credit) return this.numberWithCommas(this.sites_credit[key].credit)
      return 0.00
    },
    async gotoGame (item) {
      if (item.status) {
        const user = localStorage.getItem('userData')
        if (user) {
          const _user = JSON.parse(user)
          if (_user.key) {
            const { data } = await axios.get(`https://api.supermax168.in/api/login/${_user.key}/${item.key}/${this.mobileCheck()}`)
            if (data.status && data.url) {
              window.open(data.url, '_blank')
            } else {
              this.$swal({ icon: 'error', title: 'ปิดปรับปรุงระบบ', text: 'กรุณารอซักครู่' })
            }
          }
        }
      }
    },
    mobileCheck () {
      let check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    }
  }
}
</script>
